export default __webpack_public_path__ + "fac7f0f82ced25b86b6fa31aa97407f0.svg";